import { create } from 'zustand';

import type { AuthStore, User } from '../types';

const SUPERADMIN_ROLE = 'superadmin';

export const useAuthStore = create<AuthStore>()((set, get) => ({
  // State
  user: null,
  isAuthenticated: false,
  isLoading: true,

  // Actions
  setUser: (user: User) => {
    set({ user, isAuthenticated: true, isLoading: false });
  },

  clearUser: () => {
    set({ user: null, isAuthenticated: false, isLoading: false });
  },

  setLoading: (isLoading: boolean) => {
    set({ isLoading });
  },

  hasAccess: (resource: string, action: string) => {
    const { user } = get();

    if (!user) return false;

    // Superadmin has access to everything
    if (user.role?.name === SUPERADMIN_ROLE) return true;

    // Check permissions
    const target = `${resource}:${action}`.toLowerCase();
    return (
      user.role?.permissions?.some(
        (perm) => typeof perm?.name === 'string' && perm.name.toLowerCase() === target
      ) ?? false
    );
  },

  logout: () => {
    // Clear tokens from localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    // Clear auth cookie
    document.cookie = 'token=; Max-Age=0; path=/';

    // Clear user state
    set({ user: null, isAuthenticated: false, isLoading: false });
  },
}));
